var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":"date","min":_vm.minimum ? _vm.format(_vm.minimum) : null},domProps:{"value":_vm.formatted},on:{"input":function($event){return _vm.emit($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }